module.exports = "/fonts/fa-regular-400.ttf?db78b9359171f24936b16d84f63af378";